import { render, staticRenderFns } from "./VIPPay.vue?vue&type=template&id=50647bee&scoped=true&"
import script from "./VIPPay.vue?vue&type=script&lang=js&"
export * from "./VIPPay.vue?vue&type=script&lang=js&"
import style0 from "./VIPPay.vue?vue&type=style&index=0&id=50647bee&lang=less&scoped=true&"
import style1 from "./VIPPay.vue?vue&type=style&index=1&id=50647bee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50647bee",
  null
  
)

export default component.exports